import { useQueryGtfsResourceById } from "../../Queries";
import { useContext, useState, useEffect, useId } from "react";
import { ToolsContext } from "../../ToolsContext";
import { RLayer, RPopup, RSource, useMap } from "maplibre-react-components";
import { LngLatBounds } from "maplibre-gl"

export function TripsMl() {
    const tool = useContext(ToolsContext);
    const GTrip = tool.propertyEditor.edit;
    const {isPending: stopsIsPending, error: stopsError, data: stopsData} = useQueryGtfsResourceById('trips',GTrip.trip_id,'stop_times');
    const {isPending: shapeIsPending, error: shapeError, data: shapeData} = useQueryGtfsResourceById('shapes',GTrip.shape_id);    const id = useId();
    const map = useMap("map-ml");
  
    const Layers = [];

    useEffect(() => {

        /** trochę skomplikowana procedura dostosowywania mapy do 
         * kształtu linii komunikacyjnej na mapie, zaczerpnięta
         * z przykładu w dokumentacji maplibre: 
         * 
         * https://maplibre.org/maplibre-gl-js/docs/examples/zoomto-linestring/
         * 
         * */ 
        if (!shapeData) return;
        const coordinates = shapeData;

        const bounds = coordinates.reduce((bounds, coord) => {
            return bounds.extend(coord);
        }, new LngLatBounds(coordinates[0], coordinates[0]));

        map.fitBounds(bounds, {
            padding: 20
        });
    },[stopsData,shapeData]);


    if (shapeIsPending || shapeError || !shapeData  
        || stopsIsPending || stopsError || !stopsData )
        return;

    const layout = {
        'line-cap': 'round',
        'line-join': 'round',
    }

    const paint = { 
        'line-color': '#0000ff',
        'line-width': 4,
        //'line-opacity': 0.55
    };

    const stopPaint = {
        'circle-radius': 4,
        'circle-color': '#ffffff',
        'circle-stroke-width': 2,
        'circle-stroke-color': '#0000ff'
    }

    /** Kształt trasy kursu */

    Layers.push(
        <>
            <RSource
                id={'S' + GTrip.trip_id}
                type="geojson"
                data={
                    {
                        "type": "FeatureCollection",
                        "features": [
                            {
                                "type": "Feature",
                                "geometry": {
                                    "coordinates": [...shapeData],
                                    "type": "LineString"
                                }
                            }
                        ]
                    }
                }
            />
            <RLayer
                source={'S' + GTrip.trip_id }
                id={'L' + GTrip.trip_id }
                type="line"
                paint={paint}
                layout={layout}
            />
        </>
    )

    /** Punkty przystanków  */

    const stopsFeatures = stopsData.map((stopTime, index) => {
        return {
            "type": "Feature",
            "properties": {
                "stopIndex": index,
                "stopName": stopTime.stop_name,
                "arrivalTime": stopTime.arrival_time,
                "departureTime": stopTime.departure_time
            },
            "geometry": {
                "coordinates": [
                    stopTime.stop_lon,
                    stopTime.stop_lat
                ],
                "type": "Point"
            }
        }
    });

    Layers.push(
        <>
            <RSource
                id={'St' + GTrip.trip_id + '_'}
                type="geojson"
                data={
                    {
                        "type": "FeatureCollection",
                        "features": [
                            ...stopsFeatures
                        ]
                    }
                }
            />
            <StopTimesLayer
                source={'St' + GTrip.trip_id + '_'}
                id={'Lt' + GTrip.trip_id + '_'}
                type="circle"
                paint={stopPaint}
            />
        </>
    )

    return (
        <>
            {Layers}
        </>
    )
}

/** Warstewa z przystankami + popup/tooltip */
function StopTimesLayer({source, id, type, paint}) {
    const [tooltip,setTooltip] = useState(null);


    const popupStopTime = <RPopup latitude={tooltip ? tooltip.lat : false} longitude={tooltip ? tooltip.lng : false}>
        {tooltip && tooltip.content}
    </RPopup>

    return (
        <>        
            { tooltip ? popupStopTime : <></> }

            <RLayer
                source={source}
                id={id}
                type={type}
                paint={paint}
                onMouseEnter={(e) => {
                    console.log('me',e)
                    setTooltip({
                        lat: e.lngLat.lat,
                        lng: e.lngLat.lng,
                        content:  (
                            <>
                                {e.features[0].properties.stopIndex}.)
                                <b> {
                                    ' ' + ((e.features[0].properties.arrivalTime === e.features[0].properties.departureTime)
                                        ? e.features[0].properties.departureTime
                                        : e.features[0].properties.arrivalTime + '—' + e.features[0].properties.departureTime)
                                    + ' '
                                } </b>

                                {e.features[0].properties.stopName}
                            </>

                        )
                    })
                }}
                onMouseLeave={(e) => {
                    setTooltip(null)
                }}
            />
        </>
    )
}